const TedOneLineChatIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.66675 7H10.3334"
      stroke="#2A60DF"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.66659 12.2839H7.33325L10.2999 14.2572C10.7399 14.5505 11.3333 14.2372 11.3333 13.7039V12.2839C13.3333 12.2839 14.6666 10.9505 14.6666 8.95052V4.95052C14.6666 2.95052 13.3333 1.61719 11.3333 1.61719H4.66659C2.66659 1.61719 1.33325 2.95052 1.33325 4.95052V8.95052C1.33325 10.9505 2.66659 12.2839 4.66659 12.2839Z"
      stroke="#2A60DF"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default TedOneLineChatIcon;
